import { apiSlice } from "../../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTablesdata: builder.mutation({
      query: ({ connectionId, selectedTable }) => ({
        url: "/connectpg/showColumns",
        method: "POST",
        body: {
          connectionId,
          selectedTable,
        },
      }),
      // Invalidate the 'DataSource' tag so that queries with this tag are refetched
      invalidatesTags: ["DataSource"],
    }),
    getDatasource: builder.query({
      query: () => ({
        url: "/connectpg/getdataSources",
        method: "GET",
      }),
      // Provide a tag that will allow it to be invalidated
      providesTags: ["DataSource"],
    }),
    refetchColumnDetails: builder.mutation({
      query: (dataSourceID) => ({
        url: "/connectpg/refetchColumnDetails",
        method: "POST",
        body: { dataSourceID },
      }),
    }),
    getuploadCsv: builder.mutation({
      query: ({ formData }) => {
        console.log(formData);
        return {
          url: "/pthon/upload",
          method: "POST",
          body: formData,
        };
      },
      // Add invalidatesTags to specify which tags should be invalidated after this mutation
      invalidatesTags: ["DataSource"],
    }),
  }),
});

export const {
  useGetTablesdataMutation,
  useGetDatasourceQuery,
  useGetuploadCsvMutation,
} = sqlApiSlice;
